// extracted by mini-css-extract-plugin
export var changeIcon = "_5u-4";
export var container = "_5u-0";
export var divider = "_5u-7";
export var externalLinkIcon = "_5u-1";
export var green = "_5u-5";
export var helpCircleIcon = "_5u-3";
export var iconButton = "_5u-2";
export var red = "_5u-6";